import React from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { LayoutDashboard, Package, User, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import ScrollToTop from '../ui/ScrollToTop';
import Footer from './Footer';
import Swal from 'sweetalert2';
import './AppShell.css';

const AppShell = () => {
  const { member, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    Swal.fire({
      title: 'ออกจากระบบ?',
      text: "คุณต้องการออกจากระบบใช่หรือไม่?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#10b981',
      cancelButtonColor: '#ef4444',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
      shape: 'round',
      customClass: {
        container: 'swal-mobile-padding'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        navigate('/login');
      }
    });
  };

  const navItems = [
    { path: '/', icon: <LayoutDashboard size={24} />, label: 'สรุปข้อมูล' },
    { path: '/pinto', icon: <Package size={24} />, label: 'ปิ่นโตของคุณ' },
    { path: '/profile', icon: <User size={24} />, label: 'ข้อมูลส่วนตัว' },
  ];

  return (
    <div className="app-shell">
      {/* Top Navigation (Desktop) */}
      <header className="top-nav">
        <div className="container top-nav-container">
          <div className="brand">
            <span className="brand-text">Clean Food CR</span>
          </div>
          
          <nav className="desktop-nav">
            {navItems.map((item) => (
              <NavLink 
                key={item.path} 
                to={item.path} 
                className={({isActive}) => `desktop-nav-link ${isActive ? 'active' : ''}`}
                end={item.path === '/'}
              >
                {item.icon}
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="user-section">
            {/* {member && (
              <span className="welcome-text">สวัสดี คุณ{member.full_name?.split(' ')[0]}</span>
            )} */}
            <button className="logout-btn-desktop" onClick={handleLogout} title="ออกจากระบบ">
              <LogOut size={20} />
            </button>
          </div>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="main-content">
        <div className="container">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </div>
      </main>

      {/* Footer Area */}
      <Footer />

      {/* Floating Scroll to Top Button */}
      <ScrollToTop />

      {/* Bottom Navigation (Mobile) */}
      <nav className="bottom-nav">
        {navItems.map((item) => (
          <NavLink 
            key={item.path} 
            to={item.path} 
            className={({isActive}) => `bottom-nav-link ${isActive ? 'active' : ''}`}
            end={item.path === '/'}
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default AppShell;
